module.exports = __webpack_public_path__ + "img/syukyaku-top-019.5911d11b.jpg";